module.exports = __webpack_public_path__ + "img/header_background@2x.9509beb1.jpg";